import * as helper from './../../../../../VX/View/Assets/Js/helper';

export interface IPerson {
	id: number;
	name: string;
	avatar: string;
	age: number;
	album: string[];
}

export function getGirl(): IPerson {
	const chat = helper.$('#chatroom');
	let girls: IPerson[] = JSON.parse(helper.getData(chat, 'girls'));
	return girls[0];
}

export function getPerson(placeholder: string): IPerson {
	const chat = helper.$('#chatroom');
	let girls: IPerson[] = JSON.parse(helper.getData(chat, 'girls'));
	let boys: IPerson[] = JSON.parse(helper.getData(chat, 'boys'));

	const matched = placeholder.match(/([fm])_model(\d)/);
	if (matched === null) {
		return {
			age: 20, album: [], avatar: "", id: 0, name: ""
		}
	}

	const [, type, position] = matched;
	let person;
	switch (type) {
		case 'm':
			person = boys[parseInt(position) - 1];
			break;
		default:
			person = girls[parseInt(position) - 1];
			break;
	}
	return person;
}
